(function () {
  let observer;
  let queue = [];
  let processingQueue = false;

  const initializeCard = (card) => {
    if (!card.isConnected || card.dataset.productCardSliderInitialized) return;

    const slider = card.querySelector(".swiper-container");
    if (!slider) return;

    const initializationStartedAt = performance.now();
    const slideCount = slider.querySelectorAll(".swiper-slide").length;

    card.dataset.productCardSliderInitialized = "true";
    slider.classList.add("slider_started");

    new Swiper(slider, {
      slidesPerView: 1,
      speed: 650,
      spaceBetween: 2,
      loop: slider.dataset.loop === "true",
      navigation: {
        nextEl: card.querySelector(".swiper-button-next-1"),
        prevEl: card.querySelector(".swiper-button-prev-1"),
      },
      pagination: {
        el: card.querySelector(".product-card-pagination"),
        clickable: true,
      },
    });

    console.log("[product-card-slider] swiper initialized", {
      duration: performance.now() - initializationStartedAt,
      slideCount,
      loop: slider.dataset.loop === "true",
    });

    // The cursor is positioned relative to the first button group (the left
    // group). Keeping it there lets its transform use the card's coordinates.
    // Selecting the cursor inside .button-next offsets it by that group's
    // width, which makes the desktop direction indicator appear on the wrong
    // side after a filtered grid has been initialized.
    const cursor = card.querySelector(".product__cursor");
    const cursorIcon = card.querySelector("#cursor-icon1");
    if (!cursor || !cursorIcon) return;

    card.addEventListener("mousemove", (event) => {
      if (event.target.closest(".link") || event.target.closest(".swiper-pagination")) {
        cursor.classList.remove("active");
        return;
      }

      const rect = card.getBoundingClientRect();
      const x = event.clientX - rect.left - 12;
      const y = event.clientY - rect.top - 12;
      cursor.classList.add("active");
      cursor.animate(
        { transform: `translate(${x}px, ${y}px)` },
        { duration: 300, fill: "forwards" }
      );

      const direction = event.clientX - rect.left < card.clientWidth / 2 ? "prev" : "next";
      cursor.dataset.type = direction;
      cursorIcon.className = direction;
    });

    card.addEventListener("mouseleave", () => cursor.classList.remove("active"));

  };

  const processQueue = () => {
    processingQueue = false;
    const card = queue.shift();
    if (card) initializeCard(card);
    if (queue.length) {
      processingQueue = true;
      requestAnimationFrame(processQueue);
    }
  };

  const enqueue = (card) => {
    if (card.dataset.productCardSliderInitialized || queue.includes(card)) return;
    queue.push(card);
    if (!processingQueue) {
      processingQueue = true;
      requestAnimationFrame(processQueue);
    }
  };

  window.initializeProductCardSliders = (root = document) => {
    observer?.disconnect();
    queue = queue.filter((card) => card.isConnected);

    const cards = Array.from(root.querySelectorAll(".card--product_cursor"))
      .filter((card) => !card.dataset.productCardSliderObserved);

    if (!window.IntersectionObserver) {
      cards.forEach((card) => enqueue(card));
      return;
    }

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        enqueue(entry.target);
      });
    }, { rootMargin: "200px 0px" });

    cards.forEach((card) => {
      card.dataset.productCardSliderObserved = "true";
      card.addEventListener("pointerenter", () => enqueue(card), { once: true, passive: true });
      observer.observe(card);
    });
  };

  window.initializeProductCardSliders();
})();
